import { Link } from "react-router-dom";
import Footer from "@/components/site/Footer";
import BookingSidebar from "@/components/site/BookingSidebar";
import banteayHero from "@/assets/tour-banteay-srei-hero.jpg";


const schedule = [
  { time: "7:30 AM", title: "Hotel Pickup", body: "Hotel pickup in Siem Reap in a comfortable, air-conditioned vehicle." },
  { time: "8:30 AM", title: "Banteay Srei", body: "Arrive at Banteay Srei explore the intricate pink sandstone carvings of the 'Citadel of Women', the finest in all of Angkor." },
  { time: "10:00 AM", title: "Drive to Grand Circuit", body: "Scenic drive through the Cambodian countryside to the Grand Circuit temples." },
  { time: "10:30 AM", title: "Preah Khan", body: "Visit the sprawling Preah Khan temple complex, once home to a Buddhist university and over 1,000 teachers." },
  { time: "11:30 AM", title: "Neak Pean", body: "Explore the unique Neak Pean island temple, surrounded by four symbolic pools representing earth, water, fire and wind." },
  { time: "12:00 PM", title: "Lunch Break", body: "Lunch break at a local restaurant (not included)." },
  { time: "1:00 PM", title: "Ta Som", body: "Visit the charming Ta Som temple, famous for its eastern gateway entwined by an enormous strangler fig tree." },
  { time: "2:00 PM", title: "East Mebon", body: "Explore East Mebon, an impressive 10th-century temple built on what was once an artificial island in the East Baray reservoir." },
  { time: "3:00 PM", title: "Pre Rup", body: "Visit Pre Rup a stunning pyramid temple offering panoramic views over the surrounding jungle." },
  { time: "4:00 PM", title: "Return to Hotel", body: "Return to your hotel with unforgettable memories and a camera full of stunning photos." },
];

const TourBanteaySreiGrandCircuit = () => {
  return (
    <main className="bg-background">
      {/* HERO */}
      <header className="relative bg-jungle text-background overflow-hidden">
        <img
          src={banteayHero}
          alt="Banteay Srei pink sandstone carvings — private Grand Circuit tour with French-speaking guide in Siem Reap"
          width={1920}
          height={1280}
          className="absolute inset-0 h-full w-full object-cover opacity-60"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-jungle/70 via-jungle/50 to-jungle/95" />
        <div className="relative z-10">
          <div className="container flex items-center justify-between py-6">
            <Link to="/" className="flex items-center gap-2">
              <span className="font-display text-2xl tracking-wide">Aṅkor</span>
              <span className="text-[10px] uppercase tracking-[0.3em] opacity-70 hidden sm:inline">Sojourns</span>
            </Link>
            <Link to="/tours" className="text-[11px] uppercase tracking-[0.3em] border-b border-background/40 pb-1 hover:border-primary hover:text-primary transition-colors">
              ← All Tours
            </Link>
          </div>
          <div className="container pt-20 pb-32 md:pt-28 md:pb-44 max-w-5xl">
            <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— One Day Sojourn</p>
            <h1 className="font-display text-5xl md:text-7xl leading-[0.95] text-balance lg:text-2xl">
              Banteay Srei <em className="font-light">&</em> the Grand Circuit.
            </h1>
            <p className="mt-10 max-w-xl text-background/70 leading-relaxed text-xl font-light">
              Discover the finest masterpieces of Khmer art and architecture on a full-day journey through the Grand Circuit and the legendary 'Citadel of Women' — guided by a knowledgeable local expert.
            </p>
            <div className="mt-10 flex flex-wrap gap-x-10 gap-y-3 text-[11px] uppercase tracking-[0.3em] text-background/80">
              <span>Duration · 8.5 Hours</span>
              <span>Group · 2–15</span>
              <span>From $150 / 2 pax</span>
            </div>
          </div>
        </div>
      </header>

      {/* INTRO */}
      <section className="py-24 md:py-32">
        <div className="container max-w-4xl">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Beyond the Highlights</p>
          <h2 className="font-display text-4xl md:text-5xl leading-[1.05] mb-10 text-balance">
            A deeper exploration of Cambodia's ancient heritage.
          </h2>
          <div className="space-y-6 text-lg font-light text-muted-foreground leading-relaxed">
            <p>
              This tour takes you beyond the usual Angkor highlights from intricate pink sandstone carvings to jungle-wrapped ruins. A perfect blend of history, culture and stunning photo opportunities.
            </p>
            <p>
              You'll visit Banteay Srei, the 'Citadel of Women' with the finest carvings in Angkor; Preah Khan, once home to a Buddhist university; the island temple of Neak Pean; the tree-entwined Ta Som; East Mebon; and the panoramic pyramid of Pre Rup.
            </p>
          </div>
        </div>
      </section>


      {/* TIMELINE */}
      <section className="pb-24 md:pb-32">
        <div className="container max-w-6xl"><div className="grid lg:grid-cols-[1fr_420px] gap-x-12 gap-y-12 items-start"><div>
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Tour Schedule</p>
          <h2 className="font-display text-4xl md:text-5xl leading-[1.05] mb-16 text-balance">
            What you will do, hour by hour.
          </h2>
          <ol className="relative border-l border-border pl-8 md:pl-10 space-y-12">
            {schedule.map((s) => (
              <li key={s.time} className="relative">
                <span className="absolute -left-[41px] md:-left-[49px] top-1 h-3 w-3 rounded-full bg-primary ring-4 ring-background" />
                <p className="text-[11px] uppercase tracking-[0.3em] text-primary mb-2">{s.time}</p>
                <h3 className="font-display text-2xl md:text-3xl mb-3">{s.title}</h3>
                <p className="text-muted-foreground font-light leading-relaxed text-lg">{s.body}</p>
              </li>
            ))}
          </ol>
        </div><BookingSidebar pricePerPerson={125} tourTitle="Banteay Srei & Grand Circuit" pricingTiers={[{ maxPax: 2, price: 125 }, { maxPax: 6, price: 145 }, { maxPax: 10, price: 167 }]} /></div></div>
      </section>

      {/* INCLUDED / NOT INCLUDED */}
      <section className="bg-secondary py-24 md:py-32">
        <div className="container max-w-5xl grid md:grid-cols-2 gap-x-12 gap-y-12">
          <div>
            <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— What's Included</p>
            <ul className="space-y-4 font-light text-lg">
              <li className="border-b border-border pb-4">Air-conditioned vehicle transport</li>
              <li className="border-b border-border pb-4">English-speaking guide</li>
              <li className="border-b border-border pb-4">Cold water and towels</li>
              <li className="pb-4">Hotel pickup and drop-off</li>
            </ul>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Not Included</p>
            <ul className="space-y-4 font-light text-lg">
              <li className="border-b border-border pb-4">Angkor Pass (temple entrance fee)</li>
              <li className="border-b border-border pb-4">Meals and drinks</li>
              <li className="border-b border-border pb-4">Tips and gratuities</li>
              <li className="pb-4">Personal expenses</li>
            </ul>
          </div>
        </div>
      </section>

      {/* WHAT TO BRING */}
      <section className="py-24 md:py-32">
        <div className="container max-w-5xl">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Essential Items</p>
          <h2 className="font-display text-4xl md:text-5xl leading-[1.05] mb-16 text-balance">What to bring, what to leave behind.</h2>
          <div className="grid md:grid-cols-3 gap-x-10 gap-y-12">
            <div>
              <h3 className="font-display text-2xl mb-5">Required</h3>
              <ul className="space-y-3 font-light text-muted-foreground">
                <li>Flashlight or phone light</li>
                <li>Temple pass (US $37)</li>
                <li>Modest clothing shoulders &amp; knees covered</li>
                <li>Comfortable walking shoes</li>
              </ul>
            </div>
            <div>
              <h3 className="font-display text-2xl mb-5">Recommended</h3>
              <ul className="space-y-3 font-light text-muted-foreground">
                <li>Camera with extra batteries</li>
                <li>Small backpack</li>
                <li>Cash for breakfast</li>
                <li>Sun protection hat, sunscreen</li>
              </ul>
            </div>
            <div>
              <h3 className="font-display text-2xl mb-5">Leave at Hotel</h3>
              <ul className="space-y-3 font-light text-muted-foreground">
                <li>Passport (bring a copy)</li>
                <li>Airline tickets</li>
                <li>Excess cash</li>
                <li>Valuable jewellery</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* GOOD TO KNOW */}
      <section className="bg-secondary py-24 md:py-32">
        <div className="container max-w-4xl">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Good to Know</p>
          <div className="space-y-6 text-lg font-light text-muted-foreground leading-relaxed">
            <p>Dress code: casual but respectful  covered shoulders and knees required inside temples. Comfortable walking shoes are strongly recommended. For safety, leave valuables at your hotel and bring only what you need.</p>
            <p>This tour is not wheelchair accessible. Children under 8 years old are not permitted. Maximum group size: 2–15 travellers in an air-conditioned vehicle.</p>
            <p>
              <span className="text-foreground">Weather.</span> Hot and dry weather is expected throughout this tour. There is always the possibility of a shower or two, but it is likely to be dry most of the time. Midday temperatures can be very hot, but most of the woodland sites we visit have low humidity.
            </p>
            <p>
              <span className="text-foreground">Food.</span> Khmer cuisine is similar to most Southeast Asian cooking, but rather less spicy. Good bread is widely available thanks to the French influence, and there is a surprisingly wide range of local brews to try.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 md:py-32">
        <div className="container max-w-3xl text-center">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— $150 for two people</p>
          <h2 className="font-display text-4xl md:text-6xl leading-[1.05] mb-10 text-balance">
            Reserve your Grand Circuit day.
          </h2>
          <Link
            to="/#contact"
            className="inline-block bg-foreground text-background px-10 py-4 text-[11px] uppercase tracking-[0.3em] hover:bg-primary transition-colors"
          >
            Book Now →
          </Link>
        </div>
      </section>
      <Footer />
    </main>
  );
};

export default TourBanteaySreiGrandCircuit;
